@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.tab-label-container {
  display: flex;
  flex-basis: auto;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;

  .tab-label {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
    transition: all 200ms;
  }
  .edit-icon {
    display: flex;
    width: 18px;
    position: absolute;
    right: -15px;
    height: 18px;
    background-color: @filterview-list--container--background-color;
    transition: all 200ms;
    transform: translateX(12px);
    border-radius: 3px;
  }
}

.filterview-button {
  height: 28px;

  &:hover {
    .edit-icon {
      cursor: pointer;
      right: 12px;
    }
  }
}

.edit-svg {
  fill: @filterview-list--edit--fill-color;
  height: 18px;
  width: 18px;
}
